import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { toast } from 'sonner'

export default function useCreateMoneyPath({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    name,
    description,
    vaultId,
    percentage,
  }: {
    name: string
    description: string
    vaultId: number
    percentage: number
  }) => {
    const response = await httpClient.post(`team/money-paths`, {
      name,
      description,
      vault_id: vaultId,
      percentage,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Money Path created.')
      queryClient.invalidateQueries({ queryKey: ['money-paths'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
